import { Switch, Route, useLocation, Router as WouterRouter } from "wouter";
import { useEffect, useMemo } from "react";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import Contact from "@/pages/contact";
import About from "@/pages/about";
import Werkwijze from "@/pages/werkwijze";
import { LanguageProvider } from "@/contexts/LanguageContext";

import Scan from "@/pages/scan";
import Cases from "@/pages/cases";
import CaseDetail from "@/pages/case-detail";
import SitemapVisual from "@/pages/sitemap-visual";
import Articles from "@/pages/articles";
import ArticleDetail from "@/pages/article-detail";
import Privacy from "@/pages/privacy";
import LandingGrowthMarketing from "@/pages/landing-growth-marketing";
import LandingMetaAds from "@/pages/landing-meta-ads";
import LandingTikTokAds from "@/pages/landing-tiktok-ads";
import LandingAiMarketing from "@/pages/landing-ai-marketing";
import LandingKlaviyo from "@/pages/landing-klaviyo";
import LandingSignal from "@/pages/landing-signal";
import { Redirect } from "wouter";

function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
}

// Meta Pixel: PageView bij SPA-routewissel (initiële PageView komt uit de base code in seo-meta.ts)
function TrackPageView() {
  const [location] = useLocation();
  useEffect(() => {
    if (!(window as any).__fbqPageViewInit) {
      (window as any).__fbqPageViewInit = true;
      return;
    }
    if (typeof (window as any).fbq === 'function') {
      (window as any).fbq('track', 'PageView');
    }
  }, [location]);
  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <TrackPageView />
      <Switch>
        <Route path="/" component={Home}/>
        <Route path="/about" component={About}/>
        <Route path="/werkwijze" component={Werkwijze}/>
        <Route path="/cases" component={Cases}/>
        <Route path="/cases/:slug" component={CaseDetail}/>
        <Route path="/scan" component={Scan}/>
        <Route path="/scan/laden" component={Scan}/>
        <Route path="/scan/stap-1" component={Scan}/>
        <Route path="/scan/stap-2" component={Scan}/>
        <Route path="/scan/stap-3" component={Scan}/>
        <Route path="/scan/stap-4" component={Scan}/>
        <Route path="/scan/stap-5" component={Scan}/>
        <Route path="/scan/contact" component={Scan}/>
        <Route path="/scan/resultaat" component={Scan}/>
        <Route path="/quick-scan"><Redirect to="/scan" /></Route>
        <Route path="/contact" component={Contact}/>
        <Route path="/contact/succes" component={Contact}/>
        <Route path="/artikelen" component={Articles}/>
        <Route path="/artikelen/:slug" component={ArticleDetail}/>
        <Route path="/sitemap" component={SitemapVisual}/>
        <Route path="/privacy" component={Privacy}/>
        <Route path="/privacy-policy"><Redirect to="/privacy" /></Route>
        <Route path="/en" component={Home}/>
        <Route path="/en/about" component={About}/>
        <Route path="/en/werkwijze" component={Werkwijze}/>
        <Route path="/en/cases" component={Cases}/>
        <Route path="/en/cases/:slug" component={CaseDetail}/>
        <Route path="/en/scan" component={Scan}/>
        <Route path="/en/scan/loading" component={Scan}/>
        <Route path="/en/scan/step-1" component={Scan}/>
        <Route path="/en/scan/step-2" component={Scan}/>
        <Route path="/en/scan/step-3" component={Scan}/>
        <Route path="/en/scan/step-4" component={Scan}/>
        <Route path="/en/scan/step-5" component={Scan}/>
        <Route path="/en/scan/contact" component={Scan}/>
        <Route path="/en/scan/result" component={Scan}/>
        <Route path="/en/contact" component={Contact}/>
        <Route path="/en/contact/success" component={Contact}/>
        <Route path="/en/artikelen" component={Articles}/>
        <Route path="/en/artikelen/:slug" component={ArticleDetail}/>
        <Route path="/en/privacy" component={Privacy}/>
        <Route path="/signal" component={LandingSignal}/>
        <Route path="/growth-marketing-d2c" component={LandingGrowthMarketing}/>
        <Route path="/meta-ads-bureau-amsterdam" component={LandingMetaAds}/>
        <Route path="/meta-ads-ecommerce"><Redirect to="/meta-ads-bureau-amsterdam" /></Route>
        <Route path="/tiktok-ads-bureau" component={LandingTikTokAds}/>
        <Route path="/tiktok-ads-ecommerce"><Redirect to="/tiktok-ads-bureau" /></Route>
        <Route path="/en/signal" component={LandingSignal}/>
        <Route path="/en/growth-marketing-d2c" component={LandingGrowthMarketing}/>
        <Route path="/en/meta-ads-bureau-amsterdam" component={LandingMetaAds}/>
        <Route path="/en/meta-ads-ecommerce"><Redirect to="/en/meta-ads-bureau-amsterdam" /></Route>
        <Route path="/en/tiktok-ads-bureau" component={LandingTikTokAds}/>
        <Route path="/en/tiktok-ads-ecommerce"><Redirect to="/en/tiktok-ads-bureau" /></Route>
        <Route path="/ai-marketing-bureau" component={LandingAiMarketing}/>
        <Route path="/en/ai-marketing-bureau" component={LandingAiMarketing}/>
        <Route path="/klaviyo-email-marketing-ecommerce" component={LandingKlaviyo}/>
        <Route path="/en/klaviyo-email-marketing-ecommerce" component={LandingKlaviyo}/>
        <Route component={NotFound} />
      </Switch>
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <TooltipProvider>
          <Toaster />
          <AppRoutes />
        </TooltipProvider>
      </LanguageProvider>
    </QueryClientProvider>
  );
}

export default App;
